const config = {
    firebase: {
        apiKey: 'AIzaSyCN0HVzj1sjMzfFMG1DyYobvv5yjz7XsyM',
        authDomain: 'bulletjournalproject.firebaseapp.com',
        projectId: 'bulletjournalproject',
        storageBucket: 'bulletjournalproject.appspot.com',
        messagingSenderId: '1000487121408',
        appId: '1:1000487121408:web:990618e001793cc959dee5',
        measurementId: 'G-SGNH6PWV8L'
    },
    server: {
        url: 'http://localhost:8002', // Local ip: http://192.168.0.103:8001
        newUrl: 'http://localhost:8001'
    }
};

export default config;
